import config from "config";
import { ContentLayoutType5 } from "pages/Product/ContentLayouts/ContentLayoutType5";
import {
  AssetArea,
  DescriptionArea1,
  DescriptionArea2,
  DescriptionContent,
  DescriptionTitle,
  Image,
  SectionSubTitle,
  SectionTitle,
  TitleArea,
} from "pages/Product/ContentLayouts/styled";
import { FeatureSectionWrapper } from "pages/Product/FeaturesSection/styled";
import React from "react";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";

const StyledFeatureSectionWrapper = styled(FeatureSectionWrapper)`
  padding: 100px 26px;
  margin: 0 auto;

  ${mediaMin.xs`
    padding: 30px 26px;
  `};

  ${mediaMin.md`
    padding: 90px 26px;
  `};

  ${mediaMin.lg`
    padding: 90px 0;
  `};
`;

export function Contract() {
  return (
    <StyledFeatureSectionWrapper id="contracts">
      <ContentLayoutType5>
        <TitleArea>
          <SectionSubTitle>How can I manage</SectionSubTitle>
          <SectionTitle>Contracts?</SectionTitle>
        </TitleArea>
        <AssetArea>
          <Image
            src={`${config.RESOURCE_ORIGIN}/images/landing/product/feature-contract.png`}
          />
        </AssetArea>
        <DescriptionArea1>
          <DescriptionTitle>Templates and automation</DescriptionTitle>
          <DescriptionContent>
            Yess offers the templates reviewed by law firms and automate
            agreement generation.
          </DescriptionContent>
        </DescriptionArea1>
        <DescriptionArea2>
          <DescriptionTitle>Electronic Signature</DescriptionTitle>
          <DescriptionContent>
            Yess supports the secure electronic signature. Send, sign, and
            succeed easily.
          </DescriptionContent>
        </DescriptionArea2>
      </ContentLayoutType5>
    </StyledFeatureSectionWrapper>
  );
}
